/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// useStrict
/* global  */


expocadfx.loadScript = function( path, callback, isFile) {
	var script = document.createElement("script");
	script.type = "text/javascript";
	
	if( isFile && location.host === "www.expocad.com") {		// location.host === "192.168.110.117" || 
		path = location.origin + "/host/fx/_libs/" + path;
	}

	if (script.readyState){		//IE  ?? appears to be for < IE11
		script.onreadystatechange = function(){
			if (script.readyState === "loaded" ||
					script.readyState === "complete"){
				script.onreadystatechange = null;
				callback( true);
			}
		};
	}
	else {
		script.onload = function(){
			callback( true);
		};
		script.onerror = function() {
			callback( false);
		};
	}
	
	script.src = path;
	document.getElementsByTagName("head")[0].appendChild(script);	
};